import React, { PureComponent, lazy } from 'react';

import CookieStorageService from 'services/CookieStorageService';
import Modal from 'components/Modal/Modal';
import { getMasterDomain } from 'utils/helpers';
import trackingService from 'services/UITrackingService';

import styles from './Disclaimer.css';


const DisclaimerWithAgeVerification = lazy(() => import('./DisclaimerWithAgeVerification'));
const DisclaimerWith3Genders = lazy(() => import('./DisclaimerWith3Genders'));

export default class Disclaimer extends PureComponent {
  constructor(...args) {
    super(...args);

    const isDisclaimer18 = CookieStorageService.hasCookie('disclaimer18');

    this.state = { shouldDisplay: !isDisclaimer18 };
  }

  onAccept = (path) => {
    const domainName = getMasterDomain();
    CookieStorageService.set('disclaimer18', 'Accepted', { path: '/', domain: domainName });
    CookieStorageService.set('shouldShowGenderPopover', 'show', { path: '/', domain: domainName });

    this.setState({ shouldDisplay: false });

    trackingService.emit('consentScreenAccepted', path ? { genderPreference: path } : {});

    if (path) {
      window.location.pathname = path;
    }
  };

  onReject = () => {
    trackingService.emit('consentScreenRejected', {});
    window.location.assign('https://google.com');
  };

  renderDisclaimer = () => {
    if (window.location.pathname === '/') {
      return (
        <DisclaimerWith3Genders
          onAccept={this.onAccept}
          onReject={this.onReject}
        />
      );
    }

    return (
      <DisclaimerWithAgeVerification
        onAccept={this.onAccept}
        onReject={this.onReject}
      />
    );
  };

  render() {
    const { shouldDisplay } = this.state;

    return (
      <Modal
        className={styles.disclaimerModal}
        opaque={false}
        show={shouldDisplay}
        showClose={false}
        size="medium"
        zIndex={1500}
      >
        {this.renderDisclaimer()}
      </Modal>
    );
  }
}
